import { apiRequest } from './api';

export async function fetchFormateurSessions() {
  const response = await apiRequest('/formateur/sessions', { method: 'GET', withAuth: true });
  return response.data ?? [];
}

export async function fetchFormateurAttendance(idSession, dateSeance) {
  const q = dateSeance ? `?dateSeance=${encodeURIComponent(dateSeance)}` : '';
  const response = await apiRequest(
    `/formateur/sessions/${encodeURIComponent(idSession)}/presences${q}`,
    { method: 'GET', withAuth: true },
  );
  return response.data;
}

export async function saveFormateurAttendance(idSession, payload) {
  const response = await apiRequest(
    `/formateur/sessions/${encodeURIComponent(idSession)}/presences`,
    { method: 'POST', withAuth: true, body: JSON.stringify(payload) },
  );
  return response.data;
}

export async function archiveFormateurAttendance(idSession, payload) {
  const response = await apiRequest(
    `/formateur/sessions/${encodeURIComponent(idSession)}/presences/archiver`,
    { method: 'POST', withAuth: true, body: JSON.stringify(payload) },
  );
  return response.data;
}

export async function fetchFormateurPresenceRegistry(idSession) {
  const response = await apiRequest(
    `/formateur/sessions/${encodeURIComponent(idSession)}/presences/registre`,
    { method: 'GET', withAuth: true },
  );
  return response.data;
}

export async function fetchFormateurPresenceHistory() {
  const response = await apiRequest('/formateur/presences/historique', {
    method: 'GET',
    withAuth: true,
  });
  return response.data;
}

export function formateurPresenceExportPdfPath(idSession, dateSeance) {
  const q = `?dateSeance=${encodeURIComponent(dateSeance)}`;
  return `/formateur/sessions/${encodeURIComponent(idSession)}/presences/export.pdf${q}`;
}

export async function fetchFormateurNotesContext(idSession) {
  const response = await apiRequest(
    `/formateur/sessions/${encodeURIComponent(idSession)}/notes`,
    { method: 'GET', withAuth: true },
  );
  return response.data ?? [];
}

export async function saveFormateurNote(idSession, payload) {
  const response = await apiRequest(
    `/formateur/sessions/${encodeURIComponent(idSession)}/notes`,
    { method: 'POST', withAuth: true, body: JSON.stringify(payload) },
  );
  return response.data;
}

export async function uploadFormateurNoteFile(file) {
  const form = new FormData();
  form.append('file', file);
  const uploadRes = await apiRequest('/auth/upload-registration-document', {
    method: 'POST',
    withAuth: true,
    body: form,
  });
  const path = uploadRes?.data?.path || uploadRes?.data?.url;
  if (typeof path === 'string' && path.startsWith('/uploads/')) {
    return path;
  }
  if (typeof uploadRes?.data?.url === 'string') {
    try {
      return new URL(uploadRes.data.url).pathname;
    } catch {
      return uploadRes.data.url;
    }
  }
  throw new Error('Réponse upload invalide');
}

export async function fetchFormateurProfil() {
  const response = await apiRequest('/formateur/profil', { method: 'GET', withAuth: true });
  return response.data;
}

export async function patchFormateurProfil(payload) {
  const response = await apiRequest('/formateur/profil', {
    method: 'PATCH',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response.data;
}

export async function fetchFormateurRemuneration() {
  const response = await apiRequest('/formateur/remuneration', { method: 'GET', withAuth: true });
  return response.data;
}

export async function fetchFormateurPrestations() {
  const response = await apiRequest('/formateur/prestations', { method: 'GET', withAuth: true });
  return response.data ?? [];
}

export async function fetchFormateurAcademicPerformance() {
  const response = await apiRequest('/formateur/performance-academique', {
    method: 'GET',
    withAuth: true,
  });
  return response.data;
}

export async function fetchFormateurDocuments() {
  const response = await apiRequest('/formateur/documents', { method: 'GET', withAuth: true });
  return response.data ?? [];
}

export async function addFormateurDocument(payload) {
  const response = await apiRequest('/formateur/documents', {
    method: 'POST',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response.data;
}

const API_ROOT = (process.env.REACT_APP_API_URL || 'http://localhost:3000/api').replace(/\/$/, '');

export async function uploadProfilePhoto(file) {
  const token = localStorage.getItem('onego_access_token');
  const form = new FormData();
  form.append('file', file);
  const res = await fetch(`${API_ROOT.replace(/\/api$/, '')}/api/profile/upload-image`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  const json = await res.json();
  if (!res.ok || !json.success) throw new Error(json.message || 'Upload échoué');
  return json.data?.path ?? json.data?.url;
}

export async function uploadFormateurCv(file) {
  const token = localStorage.getItem('onego_access_token');
  const form = new FormData();
  form.append('file', file);
  const res = await fetch(`${API_ROOT}/formateur/upload-cv`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  const json = await res.json();
  if (!res.ok || !json.success) throw new Error(json.message || 'Upload échoué');
  return json.data?.url ?? json.data?.path;
}

export async function fetchFormateurElearningFilieres() {
  const response = await apiRequest('/formateur/elearning/filieres', { method: 'GET', withAuth: true });
  return response.data ?? [];
}

export async function fetchFormateurElearningRessources(idFiliere) {
  const response = await apiRequest(`/formateur/elearning/ressources?idFiliere=${encodeURIComponent(idFiliere)}`, {
    method: 'GET',
    withAuth: true,
  });
  return response.data ?? [];
}

export async function createFormateurElearningRessource(payload) {
  const response = await apiRequest('/formateur/elearning/ressources', {
    method: 'POST',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response.data;
}

export async function updateFormateurElearningRessource(id, payload) {
  const response = await apiRequest(`/formateur/elearning/ressources/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response.data;
}

export async function deleteFormateurElearningRessource(id) {
  const response = await apiRequest(`/formateur/elearning/ressources/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    withAuth: true,
  });
  return response.data;
}

export async function fetchFormateurElearningForums(idFiliere) {
  const q = idFiliere ? `?idFiliere=${encodeURIComponent(idFiliere)}` : '';
  const response = await apiRequest(`/formateur/elearning/forums${q}`, { method: 'GET', withAuth: true });
  return response.data ?? [];
}

export async function fetchFormateurElearningForumMessages(idForum) {
  const response = await apiRequest(`/formateur/elearning/forums/${encodeURIComponent(idForum)}/messages`, {
    method: 'GET',
    withAuth: true,
  });
  return response.data ?? [];
}

export async function moderateFormateurElearningForumMessage(messageId, payload) {
  const response = await apiRequest(`/formateur/elearning/forums/messages/${encodeURIComponent(messageId)}`, {
    method: 'PATCH',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response.data;
}

export async function postFormateurElearningForumMessage(idForum, payload) {
  const response = await apiRequest(`/formateur/elearning/forums/${encodeURIComponent(idForum)}/messages`, {
    method: 'POST',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response.data;
}

export async function fetchFormateurElearningCours(idFiliere) {
  const response = await apiRequest(`/formateur/elearning/cours?idFiliere=${encodeURIComponent(idFiliere)}`, {
    method: 'GET',
    withAuth: true,
  });
  return response.data ?? [];
}

export async function createFormateurElearningCours(payload) {
  const response = await apiRequest('/formateur/elearning/cours', {
    method: 'POST',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response.data;
}

export async function updateFormateurElearningCours(id, payload) {
  const response = await apiRequest(`/formateur/elearning/cours/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response.data;
}

export async function deleteFormateurElearningCours(id) {
  const response = await apiRequest(`/formateur/elearning/cours/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    withAuth: true,
  });
  return response.data;
}

export async function fetchFormateurExercicesEnAttente(idFiliere) {
  const q = idFiliere ? `?idFiliere=${encodeURIComponent(idFiliere)}` : '';
  const response = await apiRequest(`/formateur/elearning/exercices/en-attente${q}`, {
    method: 'GET',
    withAuth: true,
  });
  return response.data ?? [];
}

export async function correctFormateurExerciceReponse(reponseId, payload) {
  const response = await apiRequest(`/formateur/elearning/exercices/reponses/${encodeURIComponent(reponseId)}`, {
    method: 'PATCH',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response.data;
}

export async function fetchFormateurEvaluationCohortes() {
  const response = await apiRequest('/formateur/evaluations/cohortes', { method: 'GET', withAuth: true });
  return response.data ?? [];
}

export async function fetchFormateurEvaluations() {
  const response = await apiRequest('/formateur/evaluations', { method: 'GET', withAuth: true });
  return response.data ?? [];
}

export async function createFormateurEvaluation(payload) {
  const response = await apiRequest('/formateur/evaluations', {
    method: 'POST',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response.data;
}

export async function fetchFormateurEvaluationDetail(id) {
  const response = await apiRequest(`/formateur/evaluations/${encodeURIComponent(id)}`, {
    method: 'GET',
    withAuth: true,
  });
  return response.data;
}

export async function publishFormateurEvaluation(id) {
  const response = await apiRequest(`/formateur/evaluations/${encodeURIComponent(id)}/publier`, {
    method: 'POST',
    withAuth: true,
  });
  return response;
}

export async function launchLiveFormateurEvaluation(id) {
  const response = await apiRequest(`/formateur/evaluations/${encodeURIComponent(id)}/lancer-live`, {
    method: 'POST',
    withAuth: true,
  });
  return response;
}

export async function closeFormateurEvaluation(id) {
  const response = await apiRequest(`/formateur/evaluations/${encodeURIComponent(id)}/cloturer`, {
    method: 'POST',
    withAuth: true,
  });
  return response;
}

export async function fetchFormateurEvaluationLiveStatus(evaluationId) {
  const response = await apiRequest(
    `/formateur/evaluations/${encodeURIComponent(evaluationId)}/live-status`,
    { method: 'GET', withAuth: true },
  );
  return response.data;
}

export async function fetchFormateurEvaluationTentatives(evaluationId) {
  const response = await apiRequest(
    `/formateur/evaluations/${encodeURIComponent(evaluationId)}/tentatives`,
    { method: 'GET', withAuth: true },
  );
  return response.data ?? [];
}

export async function fetchFormateurTentativeDetail(tentativeId) {
  const response = await apiRequest(
    `/formateur/evaluations/tentatives/${encodeURIComponent(tentativeId)}`,
    { method: 'GET', withAuth: true },
  );
  return response.data;
}

export async function gradeFormateurTentative(tentativeId, payload) {
  const response = await apiRequest(
    `/formateur/evaluations/tentatives/${encodeURIComponent(tentativeId)}`,
    { method: 'PATCH', withAuth: true, body: JSON.stringify(payload) },
  );
  return response.data;
}

export async function uploadFormateurElearningFile(file) {
  const token = localStorage.getItem('onego_access_token');
  const form = new FormData();
  form.append('file', file);
  const res = await fetch(`${API_ROOT}/formateur/elearning/upload`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  const json = await res.json();
  if (!res.ok || !json.success) throw new Error(json.message || 'Upload échoué');
  return json.data;
}
